import {emptySplitApi, queryStarted} from "./api";

export const surveyApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getSurvey: builder.query({
           query: (id) => `survey/${id}`,
           providesTags: (result, error, id) => [{ type: 'Survey', id }]
        }),
        updateSurvey: builder.mutation({
           query: (data) => ({
               url: `survey`,
               method: 'POST',
               body: data
           }),
           onQueryStarted: (args, api) => queryStarted(args, api, 'getSurvey'),
           invalidatesTags: (result, error, { type: surveyType }) => [{ type: 'Survey', id: surveyType }]
        })
    })
});

export const {
    useGetSurveyQuery,
    useLazyGetSurveyQuery,
    useUpdateSurveyMutation
} = surveyApi;
